import { ZoneConfig } from 'data/generated/graphql';

import type { ContentItem } from 'contexts/datamodel/DataModelContext.core';

export const compareItems = (item1: ContentItem, item2: ContentItem) => {
  if (item1.type === item2.type) {
    if ('id' in item1.attributes && 'id' in item2.attributes) {
      return item1.attributes.id === item2.attributes.id;
    }
  }
  return false;
};

export function adjustContentIndexes(indexLists: ZoneConfig[], removedIndex: number) {
  indexLists.forEach((indexList) => {
    // Remove the deleted index
    let updatedList = indexList.contentIndexes!.filter((idx) => idx !== removedIndex);
    // Adjust remaining indexes
    updatedList = updatedList.map((idx) => (idx > removedIndex ? idx - 1 : idx));
    // Update original array
    // eslint-disable-next-line no-param-reassign
    indexList.contentIndexes!.length = 0;
    indexList.contentIndexes!.push(...updatedList);
  });
}

export const replaceZoneIdentifiers = (input: string): string =>
  input.replace(/-L_|-M_|-S_/g, (match) => {
    switch (match) {
      case '-L_':
        return '-0_';
      case '-M_':
        return '-1_';
      case '-S_':
        return '-2_';
      default:
        return match;
    }
  });
